<template>
  <div
    class="page--company-data"
    :style="`min-height: ${height}px`"
  >
    <Header
      :kind="type"
      :status="currentStatus"
      :showErrorMessage="headerErrorMessage"
      @hideErrorMessage="handleHeaderErrorMessage(false)"
    />

    <Breadcrumb
      v-if="type === 'cadastrar' && currentStatus !== 1"
      :step="currentStep"
    />

    <div v-if="isAdmin">
      <FormCompanyInfo
        v-if="currentStep === 1"
        :kind="type"
        :step="currentStep"
        :submit="submitForm"
        :data="companyData"
        :status="currentStatus"
        @tryAgain="getCompanyById"
        @setCurrentStatus="setCurrentStatus"
        @headerErrorMessage="handleHeaderErrorMessage"
      />

      <FormCompanyFinancialConfig
        v-if="currentStep === 2"
        :submit="submitForm"
        :status="currentStatus"
        @setCurrentStatus="setCurrentStatus"
      />
    </div>

    <BasicForm
      v-if="!isAdmin && hasRole('company', 'ROLE_PUT_COMPANY_ID_PHONE')"
      :kind="type"
      :step="currentStep"
      :submit="submitForm"
      :data="companyData"
      :status="currentStatus"
      @tryAgain="getCompanyById"
      @setCurrentStatus="setCurrentStatus"
      @headerErrorMessage="handleHeaderErrorMessage"
    />

    <Footer
      :kind="type"
      :step="currentStep"
      :status="currentStatus"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { mapState, mapActions } from 'vuex'
import { isObject, hasRole } from 'utils/functions'
import Header from 'components/companyData/Header'
import Breadcrumb from 'components/companyData/Breadcrumb'
import FormCompanyInfo from 'components/companyData/Form'
import BasicForm from 'components/companyData/BasicForm'
import FormCompanyFinancialConfig from 'components/companyFinancialConfig/Form'
import Footer from 'components/companyData/Footer'

export default {
  name: 'CompanyDataPage',
  components: {
    Header,
    Breadcrumb,
    FormCompanyInfo,
    BasicForm,
    FormCompanyFinancialConfig,
    Footer
  },
  computed: {
    ...mapState({
      isAdmin: state => {
        return state.session.user.business.isAdministrator ||
          state.userClaims.claims.profiles['ROLE_ADMINISTRATOR']
      }
    }),

    height () {
      return document.body.offsetHeight
    },

    type () {
      return this.$route.name === 'CreateCompany' ? 'cadastrar' : 'editar'
    },

    routeName () {
      return this.$route.name
    },

    companyId () {
      return this.$route.params ? this.$route.params.id : null
    },

    currentStep () {
      return (this.type === 'cadastrar' && !this.companyId) || (this.type === 'editar' && this.companyId) ? 1 : 2
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyDataPage',
      submitForm: false,
      companyData: null,
      currentStatus: null,
      headerErrorMessage: false
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    },

    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    handleHeaderErrorMessage (val) {
      this.headerErrorMessage = val
    },

    async getCompanyById () {
      if (this.routeName === 'EditCompany') {
        this.currentStatus = STATUS_IS_LOADING

        try {
          const companyId = Number(this.companyId)
          const { data: res } = await this.$apiService.company.getById(companyId)

          if (!this.isValidObject(res.data)) {
            throw new Error(JSON.stringify(res))
          }

          this.companyData = res.data
          this.currentStatus = STATUS_SUCCESS
        } catch (err) {
          console.log('ERROR', err)
          this.currentStatus = STATUS_FAILED
          this.errorAlert(this.$t('Messages.genericError'))
        }
      }
    }
  },
  watch: {
    companyId () {
      if (this.type === 'editar') {
        location.reload()
      }
    }
  },
  mounted () {
    this.getCompanyById()

    if (this.routeName === 'CreateCompany') {
      this.currentStatus = STATUS_SUCCESS
    }

    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
